import { graphql } from 'gatsby';
import Video from "../../../../src/components/video";
import * as React from 'react';
export default {
  graphql,
  Video,
  React
};